module.exports = __webpack_public_path__ + "img/back-arrow.bacbe5b8.svg";